module.exports = __webpack_public_path__ + "static/media/Logo_OnePay.88c1b925.svg";